import ReportFormInputWithLabel from '../Components/Global_Components/form/ReportFormInputWithLabel';
import SelectField from '../Components/Global_Components/form/SelectField';

export const labelStyles = {
  fontWeight: '600',
  marginRight: '5px',
  width: 'max-content'
};

export const yesNo = ['Yes', 'No'];

export const bmiValue = (height, weight) => {
  const h = parseFloat(height);
  const w = parseFloat(weight);

  if (!h || !w) return '';
  return ((w / (h * h)) * 10000).toFixed(2);
};

export const renderTableTD = value => {
  return <td style={{border: '1px solid black', textAlign: 'center', whiteSpace: 'pre-line'}}>{value}</td>;
};

export const renderTableTH = value => {
  return <th style={{border: '1px solid black', textAlign: 'center'}}>{value}</th>;
};

export const renderDiscPoint = () => <span style={{fontSize: '30px', display: 'flex', alignItems: 'center', height: '20px'}}>●</span>;

export const renderIndentation = () => <span style={{visibility: 'hidden', fontSize: '30px', lineHeight: '20px'}}>●</span>;

export const renderReportfield = (name, value, options = {}) => {
  const {styleSec = {}, styleLabel = {}, styleSpan = {}} = options;

  return (
    <>
      <section style={{...styleSec, margin: '0 10px 10px 10px', display: 'flex'}}>
        <label
          style={{
            ...styleLabel,
            fontWeight: '600',
            marginRight: '5px',
            width: 'max-content'
          }}>
          {name}
        </label>
        <span style={{...styleSpan, whiteSpace: 'pre-line'}}>{value}</span>
      </section>
    </>
  );
};

export const renderDynamicField = (field, formData, handleChange) => {
  const commonProps = {
    label: field.label,
    name: field.name,
    value: formData[field.name],
    onChange: handleChange
  };

  if (field.type === 'input') {
    return <ReportFormInputWithLabel {...commonProps} required={field.required ?? false} inputClassName='show' endLabel={field.endLabel} minWidth={field.minWidth} />;
  }

  if (field.type === 'select') {
    return <SelectField {...commonProps} options={field.options} placeholder={field.placeholder ?? 'Please select'} />;
  }

  return null;
};

export const handleNill = (id, setShowTables) => {
  setShowTables(prev => ({...prev, [id]: false}));
};

export const renderDynamicTable = (title, headers, fieldKeys, rows = []) => (
  <div style={{marginBottom: '15px'}}>
    <div style={{display: 'flex', marginTop: '10px'}}>
      <h6 style={{fontWeight: 600, marginRight: '5px'}}>{title}</h6>
    </div>
    <table
      style={{
        marginBottom: '10px',
        border: '1px solid black',
        width: '100%',
        textAlign: 'center',
        borderCollapse: 'collapse'
      }}>
      <thead>
        <tr>
          {headers.map((header, idx) => (
            <th
              key={idx}
              style={{
                border: '1px solid black',
                padding: '4px',
                fontWeight: 600,
                background: '#f1f1f1'
              }}>
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.isArray(rows) &&
          rows.map((row, i) => (
            <tr key={i}>
              {fieldKeys.map((key, idx) => (
                <td
                  key={idx}
                  style={{
                    border: '1px solid black',
                    padding: '4px',
                    textAlign: 'center'
                  }}>
                  {row[key] || ''}
                </td>
              ))}
            </tr>
          ))}
      </tbody>
    </table>
  </div>
);

export const RenderSignature = ({show, valueChange, handleChange, commonStyles}) => {
  if (!show) {
    return (
      <div style={{marginBottom: '20px'}}>
       
        <div style={{padding: '20px', display: 'flex', justifyContent: 'flex-end'}}>
          <div style={{display: 'flex', flexDirection: 'column', gap: '16px'}}>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: `160px 16px 200px`,
                alignItems: 'center',
                gap: '16px'
              }}>
              <span style={{fontWeight: 600, whiteSpace: 'nowrap', fontSize: '14px'}}>Androtech Name:</span>
              <span style={{fontWeight: 600, fontSize: '18px'}}>:</span>
              <input
                type='text'
                name='androtechName'
                value={valueChange.reporting?.androtechName || ''}
                onChange={handleChange}
                style={{
                  border: '1px solid #b0a4a4ff',
                  outline: 'none',
                  padding: '10px',
                  backgroundColor: 'white',
                  width: '200px'
                }}
              />
            </div>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: `160px 16px 200px`,
                alignItems: 'center',
                gap: '16px'
              }}>
              <span style={{fontWeight: 600, whiteSpace: 'nowrap', fontSize: '14px'}}>Consultant Name:</span>
              <span style={{fontWeight: 600, fontSize: '18px'}}>:</span>
              <input
                type='text'
                name='consultantName'
                value={valueChange.reporting?.consultantName || ''}
                onChange={handleChange}
                style={{
                  border: '1px solid #b0a4a4ff',
                  outline: 'none',
                  padding: '10px',
                  backgroundColor: 'white',
                  width: '200px'
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{marginTop: '20px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
      <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
        {/* Androtech Name */}
        <div style={{display: 'flex', alignItems: 'center'}}>
          <strong style={{marginRight: '210px', minWidth: '100px', fontSize: '14px', fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"}}>Androtech: {valueChange.reporting?.androtechName || ''}</strong>
        </div>

        {/* Consultant Name */}
        <div style={{display: 'flex', alignItems: 'center'}}>
          <strong style={{marginRight: '210px', minWidth: '100px', fontSize: '14px', fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"}}>Consultant: {valueChange.reporting?.consultantName || ''}</strong>
        </div>
      </div>
    </div>
  );
};
